import React from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import InternalLink from '../../../router/InternalLink';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EmdashText from '../../../components/library/common/EmdashText';
import { hasValue } from '../../../services/util/CommonUtil';
import HrbTranslate from '../../../components/language/HrbTranslate';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames'

const EmployeesQueueTableRow = ({ employee, officeId }) => {
    const averageFileTimeThreshold = 6    

    const rowFontWeight = employee.averageFileTime >= averageFileTimeThreshold ? ' office-bold-row' : ' office-normal-row'

    const history = useHistory();

    const handleClick = (ev) => {
        ev.preventDefault()
        ev.stopPropagation();

        history.push({
            pathname: `/queue/${employee.id}`,
            state: { officeId: officeId }
        });
    }

    return (
            <div className={classnames('columns light-grey level' + rowFontWeight, 'div-hover')} onClick={handleClick}>
                <div className='column is-3 pl-5'>
                    <p>{employee.firstName + ' ' + employee.lastName}</p>
                </div>
                <div className='column is-2'>
                    <p>{employee.new}</p>
                </div>
                <div className='column is-2'>
                    <p>{employee.inProgress}</p>
                </div>
                <div className='column is-2'>
                    <p>{employee.filed}</p>
                </div>
            <div className='column is-2'>               
                {!hasValue(employee.averageFileTime) ?
                    <EmdashText /> :
                    <HrbTranslate text={`Common.${employee.averageFileTime === 1 ? 'Day' : 'Days'}`}
                        params={{ Days: employee.averageFileTime }} />
                }
                </div>
                <div className='column is-1'>
                <InternalLink elementId={`link-office-${employee.id}`} to={`/queue/${employee.id}`} className='is-pulled-left' useLinkBehavior>
                    <ChevronRightIcon />
                </InternalLink>
                </div>
                <div className='column is-1'></div>
            </div >
    );
}

EmployeesQueueTableRow.propTypes = {
    employee: PropTypes.object,
}

export default EmployeesQueueTableRow